export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      /*
      badge: {
         variant: 'success',
         text: 'NEW'
       }
      */
    },
    /*
    {
      name: 'Businesses',
      url: '/businesses',
      icon: 'fa fa-building',
    },
    */
    {
      name: 'Companies',
      url: '/companies',
      icon: 'fa fa-building',
    },
    /*
    {
      name: 'Envelopes',
      url: '/envelopestatuses',
      icon: 'fa fa-envelope',
    },
    */
    {
      name: 'Cases',
      url: '/cases',
      icon: 'fa fa-briefcase',
    },
  ]
};
